import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

function readCssColor(variableName: string, fallback: string): string {
  if (typeof document === 'undefined') {
    return fallback;
  }
  const value = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
  return value || fallback;
}

export const AppThemePreset = definePreset(Aura, {
  semantic: {
    primary: palette(readCssColor('--logoColor', '#9966ff')),
  },
});
